'use client'

import { useEffect } from 'react'
import { fulfillmentRequestApi } from '@entities/fulfillment-request'

/**
 * Отметка «ответы просмотрены» уходит после того, как список заявок уже показан:
 * пометки «новый» продавец видит в этот заход и теряет их только на следующем.
 * Компонент ничего не рисует.
 */
export const MarkOffersSeen = () => {
  useEffect(() => {
    fulfillmentRequestApi.markOffersSeen().catch(() => undefined)
  }, [])

  return null
}
